import { module } from "angular";
import { TokenHolderService } from "./TokenHolderService";

module("mmAuth").service("mmTokenHolderService", TokenHolderService);
